/* eslint-disable import/prefer-default-export */
export const Categories = Object.freeze({
  WomensApparel: '女生衣著',
  MensApparel: '男生衣著',
  Beauty: '美妝保健',
  Phones: '手機平板與周邊',
  Maternity: '嬰幼兒與母親',
  Electronics: '3C與筆電',
  Houseware: '居家生活',
  HomeElectronics: '家電影音',
  WomensAccessories: '女生配件',
  MensAccessories: '男生包包與配件',
  WomensShoes: '女鞋',
  MensShoes: '男鞋',
  WomensBags: '女生包包與精品',
  Exercise: '戶外與運動用品',
  FoodAndGifts: '美食、伴手禮',
  Cars: '汽機車零件',
  Pets: '寵物',
  Music: '娛樂、收藏',
  Services: '服務、票券',
  Games: '遊戲與周邊商品',
  Books: '書籍及文創商品',
  Other: '其他類別',
});
